import React, { useState, useEffect, useRef } from 'react';
import Plot from 'react-plotly.js';
import axios from 'axios';
import useHandleErrors from '../../utils/user.utils';
import { toast } from 'react-toastify';

const AdminChartComponent = () => {
    const [onboardedData, setOnboardedData] = useState(new Array(12).fill(0));
    const [offboardedData, setOffboardedData] = useState(new Array(12).fill(0));
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const [totalCount, setTotalCount] = useState(0);
    const handleErrors = useHandleErrors();
    const hasFetchedRef = useRef(false);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const path = "/getEmployeeMasterReport";
                const URL = process.env.REACT_APP_BE_URL + path;
                const token = localStorage.getItem("token");
                const response = await axios.get(URL, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                if (response.status === 200) {
                    const { onboardEmployeeDetails, offboardEmployeeDetails } = response.data;

                    // Logging the response for debugging
                    console.log('Onboard Employee Details:', onboardEmployeeDetails);
                    console.log('Offboard Employee Details:', offboardEmployeeDetails);

                    const onboarded = new Array(12).fill(0);
                    const offboarded = new Array(12).fill(0);

                    onboardEmployeeDetails.forEach(item => {
                        const date = new Date(item.createdDate);
                        const month = date.getMonth(); // getMonth returns 0-11

                        // Logging item details for debugging
                        console.log('Onboard Item:', item);

                        // Increment the count for the respective month
                        onboarded[month] += 1;
                    });

                    offboardEmployeeDetails.forEach(item => {
                        const date = new Date(item.updatedDate);
                        const month = date.getMonth(); // getMonth returns 0-11

                        // Logging item details for debugging
                        console.log('Offboard Item:', item);

                        // Increment the count for the respective month
                        offboarded[month] += 1;
                    });

                    // Logging the processed data for debugging
                    console.log('Onboarded Data:', onboarded);
                    console.log('Offboarded Data:', offboarded);

                    setOnboardedData(onboarded);
                    setOffboardedData(offboarded.map(count => count * -1)); // Negative values for offboarded
                    setTotalCount(onboardEmployeeDetails.length - offboardEmployeeDetails.length);
                } else {
                    handleErrors(response)
                }
            } catch (error) {
                if (error.response) {
                    if (error.response.status === 404) {
                        // Handle 404 status code separately
                        setOnboardedData([]);
                        setOffboardedData([]);
                    } else {
                        handleErrors(error.response);
                    }
                } else {
                    toast.error("Something went wrong. Please try again later.", {
                        position: toast.POSITION.TOP_CENTER,
                    });
                }
            }
        };

        if (!hasFetchedRef.current) {
            fetchData();
            hasFetchedRef.current = true;
        }
    }, []);

    const trace1 = {
        x: months,
        y: onboardedData,
        type: 'bar',
        name: 'Onboarded',
        marker: {
            color: '#25B740',
        }
    };

    const trace3 = {
        x: months,
        y: offboardedData,
        type: 'bar',
        name: 'Offboarded',
        marker: {
            color: '#004F7C',
        }
    };

    const data = [trace1, trace3];

    const layout = {
        font: {
            family: 'Arial',
            size: 13,
            color: '#212529'
        },
        xaxis: {
            tickangle: 0,
            fixedrange: true,
            title: {
                text: 'Month',
                font: {
                    family: 'Arial',
                    size: 13,
                    color: '#212529'
                }
            }
        },
        yaxis: {
            range: [-20, 50],
            dtick: 20,
            showgrid: false,
            zeroline: true,
            showline: false,
            zerolinecolor: '#f1f1f3',
            zerolinewidth: 1,
            title: {
                text: 'Number of Employees',
                font: {
                    family: 'Arial',
                    size: 13,
                    color: '#212529'
                }
            },
            gridwidth: 1,
            linecolor: '#ddd',
            linewidth: 1,
            tickfont: { color: '#5a5dc69' },
            fixedrange: true
        },
        legend: {
            orientation: 'h',
            x: 0.10,
            y: -0.25,
            itemclick: false,
            itemdoubleclick: false,
        },
        barmode: 'relative',
        bargap: 0.6,
        bargroupgap: 0.2,
        barcornerradius: 15,
        automargin: true,
        gridline: false,
        showlegend: true,
        paper_bgcolor: 'rgba(255,255,255,0)',
        plot_bgcolor: 'rgba(255,255,255,0)',
        margin: { l: 50, r: 30, t: 10, b: 40, pad: 5 }
    };

    return (
        <div className="card border-none mb-4 dashboard-card">
            <div className="card-header pb-1">
                <div className="d-flex align-items-top justify-content-between">
                    <h5 className="mb-0 title">Employees Trend</h5>
                    <div className="hrs-count">
                        <span>{totalCount}</span>
                        <small className="font-size-12 text-uppercase">Total</small>
                    </div>
                </div>
            </div>
            <div className="card-body pt-0">
                <div className="row justify-content-center">
                    <div className="col-auto">
                        {new Date().getFullYear()}
                    </div>
                </div>
                <div id='currentAttritionTrend' style={{ height: '455px' }}>
                    <Plot
                        data={data}
                        layout={layout}
                        useResizeHandler
                        style={{ width: '100%', height: '100%' }}
                        config={{ responsive: true, displayModeBar: false }}
                    />
                </div>
            </div>
        </div>
    );
};

export default AdminChartComponent;
